import { configValue } from 'utils/config';

type Props = {
  originalSize: { width: number; height: number } | undefined;
  size: { width?: number; height?: number };
};

export function getFilestackImageAspectRatio({
  originalSize,
  size,
}: Props): { width: number; height: number } | undefined {
  // When Filestack mock is enabled we don't have the correct width and height
  if (configValue('filestack', 'mock')) return undefined;

  // When both width and height are provided there's no need to use aspect ratio.
  //
  // In the case where Filestack cuts/clips the image and changes its dimension it
  // would actually be incorrect to provide aspectRatio.
  if (size.width && size.height) return undefined;

  return originalSize;
}
